module.exports = __webpack_public_path__ + "static/media/profile-image-3.c5f69ae5.png";